import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input
} from '@angular/core';
import { MatInput } from '@angular/material/input';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChatService } from './chat.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButton } from '@angular/material/button';
import { LOGGER_FACTORY } from '../../../core/logger/logger-factory.provider';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatInput, ReactiveFormsModule, FormsModule, MatButton],
})
export class ChatComponent {
  readonly roomId = input<string>('global');

  private readonly _logger = inject(LOGGER_FACTORY).create('ChatComponent');
  private readonly _chat = inject(ChatService);

  messages = toSignal(this._chat.messages$);

  messageCtrl = new FormControl<string>('');

  sendMessage() {
    const message = this.messageCtrl.value;

    if (!message?.trim()?.length) {
      return;
    }

    // this._socket.instance.emit(ClientToServerEvent.SendMessage, { message, room_id: this.roomId }, (error: Error) => {
    //   if (error) {
    //     this._logger.error(`Failed to send message to room - ${error}`, { room_id: this.roomId });
    //   }
    // });

    this.messageCtrl.reset();
  }
}
